/**
 * Created by BFR on 24/02/2020.
 */
define('editPimPrintAreaView',[
  'module',
  'marionette',
  'app',
  'underscore',
  'template!editPimPrintAreaTpl',
  'dynamicTextView',
  'editPimPrintZonesView',
  'pimUtil'
], function (
  module,
  Marionette,
  App,
  _,
  viewTpl,
  DynamicTextView,
  EditPimPrintZonesView,
  PimUtil
) {
  'use strict';

  var EditPimPrintAreaView = Marionette.LayoutView.extend({
    template: viewTpl,
    className: 'pa-item',

    regions: {
      editPrintZones: '.pz-region'
    },

    events: {
      'mouseover': 'onMouseOver'
    },

    onShow: function () {
      this.editPimPrintZonesView = new EditPimPrintZonesView({
        pimProduct: this.options.pimProduct,
        collection: this.model.get('printZones')
      });
      this.getRegion('editPrintZones').show(this.editPimPrintZonesView);
    },

    onMouseOver: function () {

    },

    serializeData: function () {
      var templateData = {};

      templateData.width = this.model.get('width');
      templateData.height = this.model.get('height');
      templateData.code = this.model.get('code');

      var aNames = this.model.get('name').values;
      templateData.name = PimUtil.getTranslation(aNames);

      return templateData;
    }
  });

  module.exports = EditPimPrintAreaView;
});
